


























import Vue, { PropType } from "vue"
import FilterDescription from "~/components/custom/search/FilterDescription.vue"
import { AgeOption } from "~/clStores/profileSearchParameterOption"
import { StandardApplicationError } from "~/errorHandlers"

export interface EmitArgumentOfSelected {
  selectedOptions: AgeOption[]
}

export interface AgeModel {
  min: number | null
  max: number | null
}

export default Vue.extend({
  components: {
    FilterDescription,
  },
  props: {
    value: {
      type: Object as PropType<AgeModel>,
      required: true,
    },
    options: {
      type: Array as PropType<AgeOption[]>,
      required: true,
    },
  },
  computed: {
    minAgeIndex(): number | null {
      return (
        this.options.find((o) => o.minAgeValue === this.value.min)?.index ||
        null
      )
    },
    maxAgeIndex(): number | null {
      return (
        this.options.find((o) => o.maxAgeValue === this.value.max)?.index ||
        null
      )
    },
  },
  methods: {
    isSelected(option: AgeOption): boolean {
      return (
        !!this.minAgeIndex &&
        !!this.maxAgeIndex &&
        this.minAgeIndex <= option.index &&
        option.index <= this.maxAgeIndex
      )
    },
    toAgeOption(index: number): AgeOption {
      const target = this.options.find((o) => o.index === index)
      if (!target)
        throw new StandardApplicationError(
          "indexに該当する年齢オプションが存在しません"
        )
      return target
    },
    handleSelected(ageModel: AgeModel) {
      this.$emit("input", ageModel)
    },
    select(option: AgeOption) {
      // 現時点で何も選択されていないまたは選択中の項目が複数の場合は、今回選択されたものだけを選択した状態にする。
      if (
        !this.minAgeIndex ||
        !this.maxAgeIndex ||
        this.minAgeIndex !== this.maxAgeIndex
      ) {
        this.handleSelected({
          min: option.minAgeValue,
          max: option.maxAgeValue,
        })
        return
      }

      // １つのみ選択されている状態でその１つが選択された場合は選択を解除する。
      if (
        this.minAgeIndex === this.maxAgeIndex &&
        this.minAgeIndex === option.index
      ) {
        this.handleSelected({
          min: null,
          max: null,
        })
        return
      }

      // 現在選択されている最小年齢より低い年齢が選択された場合
      if (option.index < this.minAgeIndex) {
        this.handleSelected({
          min: option.minAgeValue, // 選択された年齢
          max: this.value.max,
        })
        return
      }

      // 現在選択されている最高年齢より高い年齢が選択された場合
      if (this.maxAgeIndex < option.index) {
        this.handleSelected({
          min: this.value.min,
          max: option.maxAgeValue, // 選択された年齢
        })
        return
      }

      throw new StandardApplicationError("年齢の選択状態が不正です")
    },
  },
})
